import React from "react";

export default function Clients() {
  return (
    <>
      <div className="client-section mt--80 d-none d-md-block d-lg-block" id={'colaboraciones'}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12">
              <div className="customer-slider-wrap client-section-wrap text-center gray-light-bg shadow-lg p-5">
                <span className="shape-left"></span>
                <span className="shape-right"></span>
                <div className="text-center">
                  <p className="lead">
                    Nuestras colaboraciones
                  </p>
                </div>
                <ul className="list-inline justify-content-between">
                  <li className="list-inline-item">
                    <img
                      src="assets/img/clients/colsan.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/clients/umana.png"
                      width="100"
                      alt="client"
                      style={{filter: "invert(1)"}}
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/clients/aloha.png"
                      width="85"
                      alt="client"
                      className="img-fluid"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/clients/competente.png"
                      width="120"
                      alt="client"
                      className="img-fluid mb-1"
                    />
                  </li>
                  <li className="list-inline-item">
                    <img
                      src="assets/img/clients/imagina.png"
                      width="85"
                      alt="client"
                      style={{filter: "invert(1)"}}
                      className="img-fluid"
                    />
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
